import { AfterViewInit, Component, ElementRef, ViewChild } from "@angular/core";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { ActivatedRoute } from "@angular/router";
import { AppConfig, AppConfigService } from "../services/app-config.service";

@Component({
    template: '<div style="height: 100%;"><iframe [src]="srcUrl" #hostIFrame style="width: 100%; height: 100%; border: 0; margin: 0; padding: 0;"></iframe></div>'
})
export class IFrameComponent implements AfterViewInit {
    srcUrl: SafeResourceUrl;

    @ViewChild('hostIFrame', { static: true }) iframe: ElementRef

    constructor(sanitizer: DomSanitizer, activatedRoute: ActivatedRoute, private appConfig: AppConfigService ) {
        const appName = activatedRoute.snapshot.data.appName;
        const config: AppConfig = this.appConfig.getConfig();
        const url = config.microfrontends[ appName ];
        this.srcUrl = sanitizer.bypassSecurityTrustResourceUrl(url);
    }

    ngAfterViewInit(): void {
        const token = localStorage.getItem('token');
        const postMessage = () => this.iframe.nativeElement.contentWindow.postMessage({ type: 'init', token: token, userEntitlements: null }, '*');
        this.iframe.nativeElement.addEventListener('load', postMessage);
    }
}
